<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-investor-change bizcomp ' + className">
            <el-row class="investor">
                <el-col :span="24" class="investor-change-tit">
                    <div class="investor-box cate">
                        <i class="investor-now" :class="{ pro: cate === '1' }" aria-hidden="true" />
                        <div class="investor-mes">
                            <span class="tit">您现在的投资者类型是</span>
                            <span class="mes">{{ cateVal }}</span>
                        </div>
                    </div>
                    <div class="investor-box">
                        <i class="investor-now" :class="{ ord: cate === '1' }" aria-hidden="true" />
                        <div class="investor-mes">
                            <span class="tit">可转换为</span>
                            <span class="mes">
                                {{ (cate === "1" ? "普通" : "专业") + "投资者" }}
                                <span v-if="innvestorInfo.status === '1'" class="red">
                                    （正在审核中）
                                </span>
                            </span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24" class="investor-info">
                    <p class="tit">一、普通投资者与专业投资者区别如下：</p>
                </el-col>
                <el-table
                    :data="differenceData"
                    style="width: 100%; color: var(--color-text-primary)"
                    border
                    :show-header="false"
                >
                    <el-table-column prop="title" width="160"></el-table-column>
                    <el-table-column prop="text" width="360"></el-table-column>
                    <el-table-column prop="value"></el-table-column>
                </el-table>
                <el-col v-if="cate === '0'" :span="24" class="investor-info">
                    <p class="tit">二、满足以下条件可由普通投资者转换为专业投资者：</p>
                </el-col>
                <el-table
                    v-if="cate === '0'"
                    :data="tableData"
                    style="width: 100%; color: var(--color-text-primary)"
                    border
                    :show-header="false"
                    :span-method="mergeCell"
                >
                    <el-table-column prop="title" width="160"></el-table-column>
                    <el-table-column prop="text" width="360"></el-table-column>
                    <el-table-column prop="value"></el-table-column>
                </el-table>
                <el-col :span="24">
                    <div class="transform-tip">
                        具体转换操作，可联系我司客服热线：{{
                            $cache.getCompanyInfoParam("10101009")
                        }}&nbsp;进行咨询。
                    </div>
                </el-col>
                <el-col class="investor-form two-cols-form" :span="24">
                    <el-col :span="24" class="btn-group">
                        <el-button
                            class="medium footer-button cancel-btn"
                            v-on:click="$router.back()"
                        >
                            返回
                        </el-button>
                    </el-col>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "InvestorDetail",
    mixins: [mixin],
    data() {
        return {
            tableData: [
                {
                    title: "法人或其他组织",
                    text: "最近年末资产",
                    value: "不低于1000万"
                },
                {
                    title: "",
                    text: "最近 1 年末金融资产",
                    value: "不低于500万"
                },
                {
                    title: "",
                    text: "投资经历",
                    value: "1 年以上证券、基金、期货、黄金、外汇等投资经历的除专业投资者外的法人或其他组织"
                },
                {
                    title: "自然人",
                    text: "金融资产或年均收入",
                    value: "金融资产不低于 300 万元或者最近 3 年个人年均收入不低于 30 万元"
                },
                {
                    title: "",
                    text: "最近 1 年末金融资产",
                    value: "1 年以上证券、基金、期货、黄金、外汇等投资经历或者 1 年以上金融产品设计、投资、风险管理及相关工作经历"
                }
            ],
            cate: "",
            cateVal: "",
            innvestorInfo: {},
            changeMsg: "",
            isPwdCheck: false,
            btnMsg: "",
            query: null,
            needtest: "",
            isAgree: false,
            differenceData: []
        };
    },
    watch: {
        cate(val) {
            this.cateVal = this.$cache.getDict("120051", val);
        }
    },
    created() {
        this.getInvestor();
        this.assignDifferenceData();
    },
    methods: {
        // 合并单元格
        mergeCell({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: 3,
                        colspan: 1
                    };
                } else if (rowIndex === 3) {
                    return {
                        rowspan: 2,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        },
        // 获取投资者转换信息
        getInvestor() {
            this.$util.getProfession((data) => {
                this.innvestorInfo = data;
                this.cate = this.innvestorInfo.professionflag;
                // this.isPwdCheck = this.cate === "0" ? this.$cache.getPwdCheck("P2") : this.$cache.getPwdCheck("P1");
                const _x = this.$cache.getUser();
                _x.professionflag = this.cate;
                _x.effectdate = this.innvestorInfo.effectdate;
                this.$store.dispatch("setInfo", _x);
            });
        },
        // 普通投资者与专业投资者区别
        assignDifferenceData() {
            this.differenceData = [
                {
                    title: "",
                    text: "专业投资者（符合下列条件之一即可）",
                    value: "普通投资者",
                    prefix: ""
                },
                {
                    title: "是否为金融机构",
                    text: "经有关金融监管部门批准设立的金融机构，包括证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司等；经行业协会备案或者登记的证券公司子公司、期货公司子公司、私募基金管理人。",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "是否为面向投资者发行的理财产品",
                    text: "上述机构面向投资者发行的理财产品，包括但不限于证券公司资产管理产品、基金管理公司及其子公司产品、期货公司资产管理产品、银行理财产品、保险产品、信托产品、经行业协会备案的私募基金",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "同时符合下列条件的法人或其他组织",
                    text: "1、 最近 1 年末净资产不低于 2000 万元2、 最近 1 年末金融资产不低于 1000 万元3、具有 2 年以上证券、基金、期货、黄金、外汇等投资经历",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "同时符合下列条件的自然人",
                    text: "1、 金融资产不低于 500 万元，或者最近 3 年个人年均收入不低于 50 万元2、 具有 2 年以上证券、基金期货、黄金、外汇等投资经历，或者具有 2 年以上金融产品设计、投资、风险管理及相关工作经历3、 金融机构高级管理人员、获职业资格认证的从事金融相关业务的注册会计师和律师",
                    value: "不要求",
                    prefix: ""
                },
                {
                    title: "是否在信息告知享有特别保护",
                    text: "不限制",
                    value: "1、可能直接导致本金亏损的事项2、 可能直接导致超过原始本金亏损的事项 3、因经营机构的业务或者财务状况变化，可能导致本金或者原始本金亏损的事项 4、因经营机构的业务或者财务状况变化，影响客户判断的重要事由5、限制销售对象权利行使期限或者可解除合同期限等全部限制内容",
                    prefix: "应告知："
                },
                {
                    title: "是否在风险警示、适当性匹配等方面享有特别保护",
                    text: "不限制",
                    value: "1、向不符合准入要求的投资者销售产品或者提供服务2、向投资者就不确定事项提供确定性的判断，或者告知投资者有可能使其误认为具有确定性的意见3、向普通投资者主动推介风险等级高于其风险承受能力的产品或者服务4、向普通投资者主动推介不符合其投资目标的产品或者服务 5、向风险承受能力最低类别的投资者销售或者提供风险等级高于其风险承受能力的产品或者服务 6、其他违背适当性要求，损害投资者合法权益的行为",
                    prefix: "禁止经营机构进行下列销售产品或者提供服务的活动："
                }
            ];
        }
    }
};
</script>
<style lang="scss">
/*用户信息 */
.bizcomp-investor-change {
    /* 为表格中的所有行添加hover效果 */
    .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
        background-color: transparent !important;
    }
    .el-table--fit {
        margin-bottom: 0;
    }
    .dialog-footer {
        text-align: center;
    }
    .title-box {
        display: flex;
        align-items: flex-end;
        margin: 0 20px;
        padding: 20px 0;
        border-bottom: 1px solid var(--color-border-base);
        .title {
            font-size: 20px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
        .tip {
            margin-left: 9px;
            font-size: 14px;
            font-weight: normal;
            margin-bottom: 2px;
            color: var(--color-text-accent);
            .content {
                color: var(--color-primary);
                cursor: pointer;
            }
        }
    }
    .investor {
        padding: 30px 20px 20px;
        .investor-change-tit {
            border: 1px solid var(--color-border-base);
            padding: 30px 0;
            text-align: center;
            .investor-box {
                display: inline-block;
                vertical-align: middle;
                &:first-of-type:after {
                    content: "";
                    width: 46px;
                    height: 15px;
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 40px;
                    background: url($investor) -139px -15px no-repeat;
                }
                &.cate {
                    .investor-now {
                        background: var(--color-primary) url($investor) 15px 11px no-repeat;
                        &.pro {
                            background: var(--color-primary) url($investor) -58px 11px no-repeat;
                        }
                    }
                    .investor-mes {
                        .tit {
                            color: var(--color-text-regular);
                        }
                        .mes {
                            color: var(--color-primary);
                        }
                    }
                }
                .investor-now {
                    width: 64px;
                    height: 64px;
                    background: #d6d6d6 url($investor) -58px 11px no-repeat;
                    display: inline-block;
                    border-radius: 100%;
                    vertical-align: middle;
                    &.ord {
                        background: #d6d6d6 url($investor) 15px 11px no-repeat;
                    }
                }
                .investor-mes {
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 12px;
                    text-align: left;
                    .tit {
                        color: $text-color3;
                        font-size: $f16;
                        line-height: 30px;
                        display: block;
                    }
                    .mes {
                        color: $text-color1;
                        font-size: $f22;
                        line-height: 30px;
                        display: block;
                        .red {
                            color: $color-c;
                        }
                    }
                }
            }
        }
        .investor-form {
            margin-top: 16px;
            .text-con {
                font-size: 16px;
                color: var(--color-text-primary);
            }
        }
    }
    .investor-info {
        background: #f9f9f9;
        border: 1px solid var(--color-border-base);
        font-size: 14px;
        font-weight: bold;
        color: var(--color-text-primary);
        padding: 20px;
        .tit {
            color: var(--color-text-primary);
            font-size: 14px;
        }
        .list {
            color: $text-color1;
            line-height: 24px;
            span {
                color: $color-c;
            }
        }
        .note {
            &:before {
                content: "*";
                color: $color-c;
            }
            color: $text-color3;
            line-height: 24px;
        }
    }
    .transform-tip {
        margin-top: 20px;
        font-size: 22px;
        color: var(--color-text-primary);
        text-align: center;
    }
    .footer-button {
        width: 180px;
        height: 42px;
        border-radius: 2px;
    }
    .footer-button:hover {
        border: none;
    }
    .cancel-btn {
        color: #ffffff;
        background: var(--color-primary);
    }
}
</style>
